import Component from '../core/Component'
import EventBus from '../core/EventBus'
import keycode from 'keycode'
import anime from 'animejs'
import { enableScrolling, disableScrolling } from '../services/Viewport/scroll'

const easing = "easeOutQuad";

export const STATES = {
    OPEN: 'is-open'
}

export default class Cart extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            closeButtons: [],
            holder: null,
            inner: null,
            overlayBorder: null
        }

        // 0 - 160
        this.borderPath = `
            M 40,-10
            L 3000,-10
            L 3000,510
            L 40,510
            Q {curve},250 40,-10
            Z`

        this.animateValues = {
            percent: 0
        }

        this.opened = false
    }

    prepare() {
        EventBus.on('cart:open', this.open)
        EventBus.on('cart:close', this.close)
        EventBus.on('cart:toggle', this.toggle)

        this.element.addEventListener('click', this.handleClick)

        document.addEventListener('keydown', event => {
            if (keycode(event.keyCode) === 'esc') {
                this.close();
            }
        });
    }

    destroy() {
        EventBus.off('cart:open', this.open)
        EventBus.off('cart:close', this.close)
        EventBus.off('cart:toggle', this.toggle)
    }

    handleClick = event => {
        let target = event.target.closest('[data-close]')
        if (target) {
            this.close()
            return
        }

        target = event.target.closest('a')
        if (!target) {
            return
        }

        if (target.classList.contains('ajax')) {
            event.preventDefault()
            return
        }

        this.close()
    }

    toggle = () => {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open = () => {
        if (this.is(STATES.OPEN)) {
            return
        }

        this.animateValues = {
            percent: 1,
        }

        anime({
            targets: this.animateValues,
            percent: 0,
            duration: 600,
            easing: easing,
            update: () => this.ref.overlayBorder.setAttribute('d', this.getBorderPath(true))
        })

        this.element.classList.add(STATES.OPEN)
        disableScrolling()
    }

    close = () => {
        if (!this.is(STATES.OPEN)) {
            return
        }

        this.animateValues = {
            percent: 1,
        }

        anime({
            targets: this.animateValues,
            percent: 0,
            duration: 1000,
            easing: easing,
            update: () => this.ref.overlayBorder.setAttribute('d', this.getBorderPath(false))
        })

        this.element.classList.remove(STATES.OPEN)
        enableScrolling()
    }

    getBorderPath (opening) {
        return this.borderPath.replace('{curve}', 40 + (opening ? 1 : -1) * (this.animateValues.percent * 40))
    }
}